import clsx from "clsx";

import ButtonNewItem from "~/components/buttons/ButtonNewItem/ButtonNewItem";
import Tooltip from "~/components/Tooltip";
import { noTrackingDayReason } from "~/modules/timeTracking/utils/noTrackingDayReason.ts";

type Props = {
	date: Date;
	canAddTracking: boolean;
	openCreate: (date: Date) => void;
	className?: string;
};

/** The "+" of a day. A disabled "+" shows why the day takes no tracking. */
export function AddTimeTrackingButton(props: Props) {
	const { date, canAddTracking, openCreate, className } = props;
	const buttonProps = { size: "sm" } as const;

	if (canAddTracking) {
		return (
			<div className={clsx("flex grow", className)}>
				<ButtonNewItem {...buttonProps}
							   onClick={() => openCreate(date)} />
			</div>
		);
	}

	return (
		<Tooltip text={noTrackingDayReason}
				 className="whitespace-pre-line">
			<div className={clsx("flex grow", className)}>
				<ButtonNewItem {...buttonProps}
							   disabled
							   onClick={() => openCreate(date)} />
			</div>
		</Tooltip>
	);
}
